import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
import { MediaContext } from '@playbookux/playbook-web-core';

const VjsSpacer = videojs.getComponent('Spacer');

const ControlBarSpacer = ({ beforeElement }) => {
  const { player } = useContext(MediaContext);

  useEffect(() => {
    const spacerBefore = new VjsSpacer(player);

    if (player) {
      const options = {
        beforeElement: 'downloadButton',
      };

      const spacerElBefore = player.controlBar.addChild(spacerBefore);
      const beforeEl = player.controlBar.getChild(beforeElement) || player.controlBar.getChild(options.beforeElement);
      player.controlBar.el()
        .insertBefore(spacerElBefore.el(), beforeEl.el());
    }
    return () => {
      if (player) {
        player.controlBar.removeChild(spacerBefore);
      }
    };
  }, [player]);

  return null;
};

ControlBarSpacer.propTypes = {
  beforeElement: PropTypes.string,
};

ControlBarSpacer.defaultProps = {
  beforeElement: null,
};

export default ControlBarSpacer;
